<template>
    <div class="tw-flex tw-flex-col tw-gap-5 tw-text-white tw-p-10 tw-max-w-xs">
      <div class="title has-text-white is-5 mb-0 pb-0">
        FAQ
      </div>

      What is the upload success rate for supported documents?
      <div class="tw-flex tw-flex-col tw-gap-5">
        <div class="tw-flex tw-gap-2">
          <i class="fas fa-check tw-self-center tw-text-[#3FA25C]" />
          <div class="tw-text-sm">
              Overall Success rate is <span class="tw-text-[#3FA25C] tw-font-bold tw-opacity-100">100%</span> 
              <br>
              <span class="tw-opacity-70">How? YourStake's team will make sure you receive the correct data output for every upload. Anytime you receive a warning message about an extraction, YourStake's team will be notified, keep you updated on the status via email, and update the portfolio in your account. The average turnaround time is just 3 hours.</span>
          </div>
        </div>
          

      </div>


      What documents are supported?
      <div class="tw-flex tw-flex-col tw-gap-5">
        <div class="tw-flex tw-gap-2">
          <i class="fas fa-check tw-self-center tw-text-[#3FA25C]" />
          <div class="tw-text-sm">
            <span class="tw-font-bold">'Standard' Brokerage statement PDFs</span> 
              <span class="tw-opacity-70">that you download from</span> 
              <span class="tw-font-bold tw-opacity-100">custodians</span>. 
              <br>
              <span class="tw-opacity-70">First-try success rate is </span>
              <span class="tw-text-[#3FA25C] tw-font-bold tw-opacity-100">96%</span> 
              <span class="tw-opacity-70">on files and high quality scans or images.</span>
          </div>
        </div>
        
        <div class="tw-flex tw-gap-2">
          <i class="fas fa-check tw-self-center tw-text-[#3FA25C]" />
          <div class="tw-text-sm">
            <span class="tw-font-bold">'Advanced' statements</span> <span class="tw-opacity-70 ">are low-quality scans that are hard for a human to read (blurry, missing data...), or non-brokerage statements containing holdings</span> <span class="tw-opacity-70">(e.g. screenshots of a web portal, performance reports, etc)</span>. <span class="tw-opacity-70">First-try success rate is </span><span class="tw-text-[#3FA25C] tw-font-bold tw-opacity-100">60%</span>
          </div>
        </div>
      </div>
      How should I upload documents for the best results?
      <div class="tw-flex tw-flex-col tw-gap-5 tw-opacity-70">
        <div class="tw-flex tw-gap-2">
          <i class="fas fa-check tw-self-center tw-text-[#3FA25C]" />
          <div class="tw-text-sm">
            <span class="tw-opacity-70">Upload the</span> <span class="tw-font-bold">entire statement </span><span class="tw-opacity-70">with pages in order</span>.
          </div>
        </div>
        <div class="tw-flex tw-gap-2">
          <i class="fas fa-check tw-self-center tw-text-[#3FA25C]" />
          <div class="tw-text-sm">
            <span class="tw-opacity-70">Upload</span> <span class="tw-font-bold">high quality scans or pictures</span>. <span class="tw-opacity-70">If it's hard for you to read (e.g. blurry, lines cut off), it's hard for our system to read</span>.
          </div>
        </div>
        <div class="tw-flex tw-gap-2">
          <i class="fas fa-check fa-times tw-self-center" />
          <div class="tw-text-sm">
            <span>Do not combine multiple statements into one PDF document. Consolidated statements are fine, but each upload should be a single statement.</span>
          </div>
        </div>
        <div class="tw-flex tw-gap-2">
          <div class="tw-text-sm">
          </div>
        </div>
      </div>
    </div>
</template>


<script>
// import SubComponent from '../components/SubComponent'

export default {
  components: { /* Subcomponents */ },
  props: [/* Inputs */],
  data() {
    return { /* Local variables */ };
  },
  computed: { /*
    Creates a new property
    Updates when any dependant property changes */
  },
  watch: { /*
    Watches an existing property
    Only runs when the watched property changes */
  },
  beforeCreate() {},
  created() {},
  mounted() {},
  updated() {},
  methods: {},
};
</script>


<style scoped>

</style>
